import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, ArrowRight } from "lucide-react";

const CtaSection = () => (
  <section className="py-20 px-6 bg-white overflow-hidden">
    <motion.div
      className="max-w-5xl mx-auto rounded-3xl py-16 px-8 text-center relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #4361EE 0%, #7C3AED 100%)" }}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      {/* Animated background orbs */}
      <motion.div
        className="absolute w-72 h-72 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: "#fff", top: "-60px", right: "-60px" }}
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute w-48 h-48 rounded-full blur-3xl opacity-10 pointer-events-none"
        style={{ background: "#fff", bottom: "-40px", left: "-40px" }}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: 1 }}
      />

      <div className="relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.5 }}
          className="flex justify-center mb-5"
        >
          <span className="inline-flex items-center gap-2 bg-white/20 border border-white/30 text-white text-xs font-semibold px-4 py-1.5 rounded-full backdrop-blur-sm">
            <Zap className="w-3 h-3" />
              Individual plan — 30-day free trial
          </span>
        </motion.div>

        <motion.h2
          className="text-3xl sm:text-4xl font-extrabold text-white mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          Start Analyzing Your Privacy Policy Today
        </motion.h2>

        <motion.p
          className="text-white/80 mb-8 text-base max-w-md mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.28, duration: 0.5 }}
        >
          Try the Individual plan free for 30 days — run up to 5 analyses at no cost. No card required, and nothing is charged unless you choose to continue.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.36, duration: 0.45, type: "spring", stiffness: 280 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <Link to="/auth/register">
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 8px 30px rgba(0,0,0,0.2)" }}
              whileTap={{ scale: 0.97 }}
              className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-primary bg-white hover:bg-white/95 transition-all text-sm shadow-lg"
            >
              Start Free Trial <ArrowRight className="w-4 h-4" />
            </motion.button>
          </Link>
          <Link to="/auth/login">
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white border border-white/40 hover:bg-white/10 transition-all text-sm"
            >
              Sign In
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </motion.div>
  </section>
);

export default CtaSection;
